<template lang="pug">
  v-dialog(
    :value="true"
    max-width="700"
    @click:outside="$modals.close()"
  )
    v-card.pa-4
      v-card-title
        h4 Поиск сотрудников
        v-spacer
        v-btn(
          fab
          text
          @click="$modals.close()"
        )
          v-icon mdi-close
      v-card-text.subtitle-1
        v-tabs(v-model="tab" grow)
          v-tab(v-for="(item, idx) in employees" v-if="item.name" :key="idx")
            v-badge(:value="item.selected.length" :content="item.selected.length")
              span {{ item.name }}
        v-tabs-items(v-model="tab")
          v-tab-item(v-for="(item, idx) in employees" v-if="item.name" :key="idx")
            server-data(
              :method="item.method"
              :response-data-serializer="item.serializer"
              searchFieldName="search[name]"
              v-slot="{ serverData, search, init, loading, pagination }"
            )
              v-text-field(
                label="Поиск"
                filled
                rounded
                @input="search"
              )
              v-scroll-y-transition(leave-absolute)
                v-skeleton-loader(
                  v-if="loading"
                  type="list-item@6"
                )
              v-list.pt-0.overflow-auto.scroll(
                v-if="!loading && serverData"
                nav
                height="400"
              )
                v-list-item(v-if="!serverData.length")
                  v-list-item-content
                    v-list-item-subtitle Доступные для выбора сотрудники не найдены...
                v-list-item-group(
                  v-model="item.selected"
                  multiple
                )
                  v-list-item(
                    v-for="staff in serverData"
                    :value="staff"
                    :key="staff.id"
                  )
                    template(v-slot:default="{ active }")
                      v-list-item-avatar
                        v-checkbox(
                          :input-value="active"
                        )
                      v-list-item-content
                        v-list-item-title {{getFio(staff)}}
              //- v-row.ma-0.mt-4.white(
              //-   style="position: sticky; bottom: 0; left: 0;"
              //- )
              v-pagination(
                v-if="pagination && pagination.pages   > 1"
                v-model="pagination.page"
                :length="pagination.pages"
                @input="init"
              )
              v-row.ma-0(v-if="item.addMethod").align-center
                span Не нашли в списке нужного сотрудника?
                v-btn(color="success" text small @click="item.addMethod(init)") Добавить
      v-card-subtitle.position-fixed(
        v-show="selected.length"
      )
        v-btn.px-4(
          color="success"
          :loading="loading.save"
          depressed
          rounded
          :disabled="!selected.length"
          @click="accept"
        ) Выбрать
</template>

<script>
import ListenerForm from '@/components/Forms/UsersListenerForm.vue';

export default {
  props: {
    courseId: { type: Number, required: true },
    excludedList: { type: Array, default: () => ([]) },
    excludedDispatcherList: { type: Array, default: () => ([]) },
    successCallback: { type: Function, default: () => ({}) },
  },
  data() {
    return {
      tab: 0,
      employees: [
        ...this.$user.isOrganization ? [{
          name: 'Преподаватели',
          method: (params) => {
            const rOptions = { many: true };
            return this.$api.teachers.index({ ...params, 'search[organization]': this.$user.organization.id }, rOptions);
          },
          selected: [],
          serializer: (data) => data.filter(
            (i) => !this.excludedList
              .includes(i.dispatcher_id ? i.dispatcher_id : i.user_id),
          ),
        }] : [{}],
        ...!this.$user.data.is_local && this.$user.isOrganization ? [{
          name: 'из ПФДО',
          method: this.$api.users.getOrganizationStaff,
          selected: [],
          serializer: (data) => data.filter(
            (i) => !this.excludedDispatcherList
              .includes(i.dispatcher_user_id ? i.dispatcher_user_id : i.id),
          ),
        }] : [{}],
        {
          name: 'Слушатели',
          method: this.$api.users.relatedUsers,
          selected: [],
          serializer: (data) => data.filter(
            (i) => !this.excludedList
              .includes(i.dispatcher_user_id ? i.dispatcher_user_id : i.id),
          ),
          addMethod: (callback) => this.openAddStaffDialog(callback),
        },
      ],
      // selected: [],
      loading: {
        save: false,
      },
    };
  },
  computed: {
    selected() {
      return this.employees.reduce((acc, curr) => acc.concat(curr.selected), []);
    },
    // staffDataSerializer() {
    //   return (data) => (
    //     data && data.filter(
    //       (i) => !this.excludedDispatcherList
    //         .includes(i.dispatcher_user_id ? i.dispatcher_user_id : i.id),
    //     ));
    // },
  },
  methods: {
    getFio(staff) {
      const lastName = staff.last_name || staff.information_surname || staff.surname;
      const firstName = staff.first_name || staff.information_first_name;
      const middleName = staff.middle_name || staff.information_patronymic || staff.patronymic;
      return `${lastName} ${firstName} ${middleName}`;
    },
    openAddStaffDialog(callback) {
      this.$modals.show('generic-controller', {
        title: 'Создать слушателя',
        component: ListenerForm,
        'component-props': {
          successCallback: () => {
            callback();
            this.$modals.close();
          },
        },
      });
    },
    async accept() {
      this.loading.save = true;
      console.log(this.employees);
      const dispatcherUsers = this.employees[1]?.selected?.map((el) => el.dispatcher_user_id) || [];
      const users = this.employees[0]?.selected?.map((el) => el.user_id) || [];
      const sdoUsers = users.concat(
        this.employees[2] ? this.employees[2].selected.map((el) => el.id) : [],
      );

      let ids = [];
      if (dispatcherUsers.length) {
        const result = await this.$api.users.saveUsersFromDispatcher(dispatcherUsers);
        ids = result.data.data.map(({ id }) => id);
      }
      const result = ids.concat(sdoUsers);

      this.$rHandler(
        this.$api.courses.staffRecordsMake(this.courseId, result),
        (resp) => {
          this.successCallback(resp, this.selected);
        },
      );

      this.loading.save = false;
    },
  },
};
</script>
<style>
.position-fixed {
  position: sticky;
  bottom: 0;
}
</style>
